import { render, staticRenderFns } from "./enterprise_category_list.vue?vue&type=template&id=8b0bc0d8&scoped=true&"
import script from "./enterprise_category_list.vue?vue&type=script&lang=js&"
export * from "./enterprise_category_list.vue?vue&type=script&lang=js&"
import style0 from "./enterprise_category_list.vue?vue&type=style&index=0&id=8b0bc0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0bc0d8",
  null
  
)

export default component.exports